"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.immunizationMessages = exports.Immunization = void 0;
const schema_1 = require("../../../schema");
var Immunization;
(function (Immunization) {
    Immunization["HEPATITIS_A"] = "hepatitis-a";
    Immunization["HEPATITIS_B"] = "hepatitis-b";
    Immunization["PNEUMOCOCCUS"] = "pneumococcus";
    Immunization["SARS_COV_2"] = "sars-cov-2";
    Immunization["MMR"] = "mmr";
})(Immunization || (exports.Immunization = Immunization = {}));
exports.immunizationMessages = {
    [Immunization.HEPATITIS_A]: {
        id: "ltx.phaseI.vaccinationStatus.immunization.HEPATITIS_A",
        defaultMessage: "Hepatitis A"
    },
    [Immunization.HEPATITIS_B]: {
        id: "ltx.phaseI.vaccinationStatus.immunization.HEPATITIS_B",
        defaultMessage: "Hepatitis B"
    },
    [Immunization.PNEUMOCOCCUS]: {
        id: "ltx.phaseI.vaccinationStatus.immunization.PNEUMOCOCCUS",
        defaultMessage: "Pneumococcus"
    },
    [Immunization.SARS_COV_2]: {
        id: "ltx.phaseI.vaccinationStatus.immunization.SARS_COV_2",
        defaultMessage: "SARS-CoV-2"
    },
    [Immunization.MMR]: {
        id: "ltx.phaseI.vaccinationStatus.immunization.MMR",
        defaultMessage: "MMR"
    }
};
const immunization = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Immunization.HEPATITIS_A),
    schema_1.Schema.singleChoiceItem(Immunization.HEPATITIS_B),
    schema_1.Schema.singleChoiceItem(Immunization.PNEUMOCOCCUS),
    schema_1.Schema.singleChoiceItem(Immunization.SARS_COV_2),
    schema_1.Schema.singleChoiceItem(Immunization.MMR)
]);
const vaccineName = schema_1.Schema.string().optional().maxLength(100);
const numberOfDoses = schema_1.Schema.number().optional().integer().min(0).max(20);
const dateOfLastDose = schema_1.Schema.string().optional().date();
const vaccineType = schema_1.Schema.array()
    .default([])
    .items(schema_1.Schema.object().default({}).sealed(true).properties({
    immunization,
    vaccineName,
    numberOfDoses,
    dateOfLastDose
}))
    .interpretation({ vocab: "ltx", code: "vaccine_type" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ vaccineType })
    .interpretation({ vocab: "ltx", code: "vaccination_status" });
